import { capitalize } from 'lodash';
import { Modalidade } from '../app-container.types';

export const tiposCompletos: Record<string, { label: string; value: string }> = {
  [Modalidade.GRAD]: { label: 'Graduação', value: 'GRAD' },
  [Modalidade.POS]: { label: 'Pós-Graduação', value: 'POS' },
  [Modalidade.TEC]: { label: 'Técnico', value: 'TEC' },
};

const tipoCursoLabelMapper: Record<string, string> = {
  ['GRADUACAO']: 'Graduação',
  ['ESPECIALIZACAO']: 'Especialização',
  ['FORMACAO PROFISSIONAL NIVEL TECNICO']: 'Formação profissional nível técnico',
};

export function getTipoDeCursoSelecionado(tipo: string): string {
  tipo = tipo.replace(/_/g, ' ');
  const label = tipoCursoLabelMapper[tipo];
  return label ?? capitalize(tipo);
}
